import { createAsyncThunk } from "@reduxjs/toolkit"
import { Order } from "@/types"
import { httpGet } from "@/lib/http"

interface FetchOrdersResponse {
  content: any[]
  last: boolean
  totalPages: number
  totalElements: number
}

export const fetchAllOrders = createAsyncThunk<Order[], void, { rejectValue: string }>(
  "orders/fetchAll",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      let allOrders: any[] = []
      let page = 0
      let hasMore = true

      while (hasMore && page < 50) {
        const res = await httpGet({ url: `admin/orders?page=${page}&size=100`, dispatch })
        if (res && res.data && res.data.orders) {
          const { content, last } = res.data.orders as FetchOrdersResponse
          if (Array.isArray(content)) {
            allOrders = [...allOrders, ...content]
          }
          hasMore = !last
          page++
        } else {
          hasMore = false
        }
      }

      const _allOrders = allOrders.map(o => ({
        id: o.id || o.orderId,
        orderId: o.orderId,
        email: o.email,
        phone: o.phone || '—',
        amount: o.amount,
        status: o.status,
        planId: o.planId,
        planName: o.selectedPlan?.title || o.selectedPlan?.name || '—',
        appliedOffer: (typeof o.coupon === 'string' ? o.coupon : o.coupon?.code) || (typeof o.appliedOffer === 'string' ? o.appliedOffer : o.appliedOffer?.code) || null,
        appliedOfferId: o.appliedOfferId || null,
        paymentGateway: o.paymentId ? 'RAZORPAY' as const : '—' as any,
        transactionId: o.paymentId || '—',
        sessionId: o.sessionId || '—',
        createdAt: o.createdAt,
        updatedAt: o.updatedAt,
        selectedPlan: o.selectedPlan,
        coupon: o.coupon,
      })) as Order[]

      return _allOrders as Order[];
    } catch (error: any) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchOrdersSummary = createAsyncThunk<any, void, { rejectValue: string }>(
  "orders/fetchSummary",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await httpGet({ url: 'admin/orders/summary', dispatch })
      return res?.data?.ordersSummary || null
    } catch (error: any) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchPendingOrders = createAsyncThunk<Order[], void, { rejectValue: string }>(
  "orders/fetchPending",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await httpGet({ url: 'orders/pending', dispatch })
      const data = res?.data
      if (!data || !Array.isArray(data)) return []
      return data.map(o => ({
        id: o.id || o.orderId,
        orderId: o.orderId,
        email: o.email,
        phone: o.phone || '—',
        amount: o.amount,
        status: o.status,
        planId: o.planId,
        planName: o.selectedPlan?.title || o.selectedPlan?.name || '—',
        appliedOffer: (typeof o.coupon === 'string' ? o.coupon : o.coupon?.code) || (typeof o.appliedOffer === 'string' ? o.appliedOffer : o.appliedOffer?.code) || null,
        appliedOfferId: o.appliedOfferId || null,
        paymentGateway: o.paymentId ? 'RAZORPAY' as const : '—' as any,
        transactionId: o.paymentId || '—',
        sessionId: o.sessionId || '—',
        createdAt: o.createdAt,
        updatedAt: o.updatedAt,
        selectedPlan: o.selectedPlan,
        coupon: o.coupon,
      })) as Order[]
    } catch (error: any) {
      return rejectWithValue(error.message)
    }
  }
)
